var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { memo } from 'react';
import * as React from "react";
var SvgImageMultiple = /*#__PURE__*/memo(function (props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11 2v6a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1ZM1 10V3h1v7h6.5a.5.5 0 0 1 0 1H2a1 1 0 0 1-1-1Zm4.25-5.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm3.5 0a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM5.398 5.698A.5.5 0 0 0 4.6 6.3L5 6l-.4.3.001.001.001.002.004.005.01.014c.01.01.021.025.036.042a3.474 3.474 0 0 0 .585.54c.4.29 1 .596 1.763.596.763 0 1.364-.305 1.763-.596a3.474 3.474 0 0 0 .62-.582l.011-.014.004-.005v-.002H9.4L9 6l.4.3a.5.5 0 0 0-.798-.602l-.003.003a2.474 2.474 0 0 1-.425.395c-.288.21-.687.404-1.174.404-.487 0-.886-.195-1.175-.404a2.474 2.474 0 0 1-.424-.395l-.003-.003Z",
    clipRule: "evenodd"
  })));
});
SvgImageMultiple.displayName = "SvgImageMultiple";
export default SvgImageMultiple;